import { Injectable } from '@angular/core';
import { Client, PeopleBriefDataDto } from '@fdm/api-client';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class GetPeopleDetailsService {
  //this is to get People details based on Object ID of user.
  constructor(private apiClient: Client) { }

  getPeopleDetailsByObjectId(azureObjectId: string): Observable<PeopleBriefDataDto> {
    return this.apiClient.azureObjectId(azureObjectId);
  }
}
